<template>
  <div class="address-info" v-loading="loadingAddressInfo">
    <basic-form
      ref="addressInfo"
      title="Addres Info"
      :mode="mode"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          plain
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// msg
// import PagesMessage from '@/core/message/pages'
// apis
// models
import { AddressInfoWrapUp, AddressInfoModifyForm } from '@/core/models/address'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicForm from '@/components/common/BasicForm.vue'
import { queryAddress } from '@/api/address'
export default {
  name: 'AddressInfo',
  components: { BasicForm },
  mixins: [pageJumps],
  props: {
    addressId: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  data() {
    return {
      FormModes,
      loadingAddressInfo: false,
      address: null,
      editing: false
    }
  },
  computed: {
    addressType() {
      return this.address?.type ?? ''
    },
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return AddressInfoWrapUp(this.address)
    },
    editInfo() {
      const form = cloneDeep(AddressInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.address[one.key]
      })
      return form
    }
  },
  watch: {
    addressId() {
      this.detailAddress()
    }
  },
  methods: {
    async detailAddress() {
      this.loadingData = true
      if (this.addressId) {
        const page = await queryAddress({
          addressIds: [this.addressId],
          size: 1
        })
        this.loadingData = false
        this.$set(this, 'address', page.records[0])
      } else {
        this.$set(this, 'address', null)
      }
    },
    saveInfo() {
      // eslint-disable-next-line no-unused-vars
      const [passed, addressInfo] = this.$refs.addressInfo.validateAllInputs()
      if (passed) {
        this.$confirm('Update Address Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$message.error('not implemented')
        })
      }
    },
    deleteAddress() {
      this.$confirm(`Delete address ${this.order.riiOrderNo}`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.$message.error('not implemented')
        })
        .catch(() => {})
    }
  },
  mounted() {
    this.detailAddress()
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.order-info {
  position: relative;
}
</style>
